import { useQuery } from '@tanstack/react-query';
import { getDollarValue, type DollarRate } from '@/services/getDollarValue';
import { queryKeys } from '@/lib/queryKeys';
import { STALE_TIME_DOLLAR } from '@/lib/queryCacheConfig';

export const useGetDollarValue = () => {
  const {
    data: rate,
    isLoading: loading,
    error,
    refetch: refresh,
  } = useQuery<DollarRate>({
    queryKey: queryKeys.dollarValue(),
    queryFn: getDollarValue,
    staleTime: STALE_TIME_DOLLAR.dollarValue,
  });

  return {
    rate: rate ?? null,
    loading,
    error: error ? (error instanceof Error ? error.message : 'Unknown Error') : null,
    refresh,
  };
};